import type { SmartComboboxOption } from "../shared/smart-combobox";

const toOptions = (values: readonly string[]): SmartComboboxOption[] =>
  values.map((value) => ({ value, label: value }));

export const POSITION_OPTIONS = toOptions([
  // Administration, direction et gestion
  "Agent administratif",
  "Assistant administratif",
  "Assistant de direction",
  "Assistant de gestion",
  "Office manager",
  "Secrétaire",
  "Secrétaire de direction",
  "Réceptionniste",
  "Standardiste",
  "Directeur général",
  "Directeur des opérations",
  "Directeur administratif et financier",
  "Directeur d’agence",
  "Gérant",
  "Chef de service",
  "Responsable administratif",
  "Responsable des services généraux",
  "Chargé de mission",
  "Chef de projet",
  "Chef de projet digital",
  "Coordinateur de projet",
  "Assistant chef de projet",
  "Consultant",
  "Consultant en organisation",
  // Finance, comptabilité, banque et assurance
  "Comptable",
  "Assistant comptable",
  "Chef comptable",
  "Expert-comptable",
  "Auditeur interne",
  "Auditeur financier",
  "Contrôleur de gestion",
  "Analyste financier",
  "Trésorier",
  "Responsable financier",
  "Gestionnaire de paie",
  "Fiscaliste",
  "Chargé de clientèle bancaire",
  "Conseiller bancaire",
  "Guichetier",
  "Caissier",
  "Analyste crédit",
  "Chargé de recouvrement",
  "Agent de microfinance",
  "Chargé de conformité",
  "Gestionnaire de risques",
  "Agent d’assurance",
  "Gestionnaire de sinistres",
  "Actuaire",
  // Commerce, vente et relation client
  "Commercial",
  "Commercial terrain",
  "Attaché commercial",
  "Technico-commercial",
  "Chargé d’affaires",
  "Business developer",
  "Responsable commercial",
  "Directeur commercial",
  "Key account manager",
  "Délégué médical",
  "Vendeur",
  "Conseiller de vente",
  "Chef de rayon",
  "Responsable de magasin",
  "Merchandiser",
  "Téléconseiller",
  "Conseiller clientèle",
  "Chargé de relation client",
  "Responsable du service client",
  "Agent commercial immobilier",
  "Acheteur",
  "Responsable des achats",
  // Marketing et communication
  "Responsable marketing",
  "Chargé de marketing",
  "Chef de produit",
  "Marketing digital manager",
  "Community manager",
  "Social media manager",
  "Chargé de communication",
  "Responsable communication",
  "Attaché de presse",
  "Rédacteur web",
  "Rédacteur",
  "Journaliste",
  "Traducteur",
  "Interprète",
  "Photographe",
  "Vidéaste",
  "Monteur vidéo",
  "Animateur radio",
  "Designer graphique",
  "Infographiste",
  "Directeur artistique",
  "Chargé d’événementiel",
  "Spécialiste SEO",
  // Informatique, numérique et télécoms
  "Développeur web",
  "Développeur frontend",
  "Développeur backend",
  "Développeur full stack",
  "Développeur mobile",
  "Ingénieur logiciel",
  "Architecte logiciel",
  "Ingénieur DevOps",
  "Ingénieur cloud",
  "Administrateur systèmes et réseaux",
  "Administrateur de bases de données",
  "Technicien informatique",
  "Technicien support",
  "Technicien réseaux et télécoms",
  "Ingénieur télécoms",
  "Ingénieur réseaux",
  "Ingénieur en cybersécurité",
  "Analyste cybersécurité",
  "Data analyst",
  "Data scientist",
  "Data engineer",
  "Ingénieur en intelligence artificielle",
  "Business analyst",
  "Product manager",
  "Product owner",
  "Scrum master",
  "UX/UI Designer",
  "Testeur QA",
  "Responsable informatique",
  "Directeur des systèmes d’information",
  // Ressources humaines et juridique
  "Responsable des ressources humaines",
  "Chargé des ressources humaines",
  "Assistant ressources humaines",
  "Chargé de recrutement",
  "Chargé de formation",
  "Juriste",
  "Juriste d’entreprise",
  "Avocat",
  "Notaire",
  "Huissier de justice",
  "Clerc de notaire",
  "Assistant juridique",
  // Ingénierie, industrie, BTP et énergie
  "Ingénieur",
  "Ingénieur génie civil",
  "Ingénieur électricien",
  "Ingénieur mécanique",
  "Ingénieur process",
  "Ingénieur pétrolier",
  "Ingénieur des mines",
  "Ingénieur qualité",
  "Ingénieur HSE",
  "Responsable HSE",
  "Responsable qualité",
  "Conducteur de travaux",
  "Chef de chantier",
  "Architecte",
  "Dessinateur projeteur",
  "Géomètre topographe",
  "Métreur",
  "Technicien de maintenance",
  "Technicien en électricité",
  "Technicien en énergie solaire",
  "Électricien",
  "Électromécanicien",
  "Mécanicien",
  "Mécanicien automobile",
  "Plombier",
  "Soudeur",
  "Maçon",
  "Menuisier",
  "Peintre en bâtiment",
  "Frigoriste",
  "Opérateur de production",
  "Chef d’équipe",
  "Responsable de production",
  "Directeur d’usine",
  // Transport et logistique
  "Logisticien",
  "Responsable logistique",
  "Gestionnaire de stock",
  "Magasinier",
  "Agent de transit",
  "Déclarant en douane",
  "Transitaire",
  "Responsable supply chain",
  "Chauffeur",
  "Chauffeur poids lourd",
  "Livreur",
  "Agent d’escale",
  "Hôtesse de l’air",
  "Steward",
  "Pilote de ligne",
  // Santé et social
  "Médecin",
  "Médecin généraliste",
  "Chirurgien",
  "Pharmacien",
  "Préparateur en pharmacie",
  "Infirmier",
  "Aide-soignant",
  "Sage-femme",
  "Technicien de laboratoire",
  "Biologiste",
  "Kinésithérapeute",
  "Dentiste",
  "Nutritionniste",
  "Psychologue",
  "Assistant social",
  "Agent de santé communautaire",
  // Éducation et formation
  "Enseignant",
  "Professeur des écoles",
  "Professeur de lycée",
  "Enseignant-chercheur",
  "Chercheur",
  "Formateur",
  "Éducateur",
  "Conseiller d’orientation",
  "Surveillant",
  "Directeur d’école",
  // Hôtellerie, restauration et tourisme
  "Chef cuisinier",
  "Cuisinier",
  "Commis de cuisine",
  "Pâtissier",
  "Boulanger",
  "Serveur",
  "Barman",
  "Maître d’hôtel",
  "Réceptionniste d’hôtel",
  "Gouvernante",
  "Femme de chambre",
  "Responsable de restaurant",
  "Directeur d’hôtel",
  "Agent de voyage",
  "Guide touristique",
  // Agriculture et environnement
  "Agronome",
  "Ingénieur agronome",
  "Technicien agricole",
  "Agriculteur",
  "Éleveur",
  "Vétérinaire",
  "Chargé de projet environnement",
  "Ingénieur environnement",
  "Forestier",
  // Sécurité, services et ONG
  "Agent de sécurité",
  "Chef de sécurité",
  "Agent d’entretien",
  "Coiffeur",
  "Esthéticienne",
  "Couturier",
  "Styliste",
  "Chargé de programme",
  "Chargé de suivi-évaluation",
  "Coordinateur humanitaire",
  "Volontaire",
  "Stagiaire",
  "Fonctionnaire",
  "Agent des impôts",
]);

export const CONTRACT_OPTIONS = [
  "CDI",
  "CDD",
  "Stage",
  "Alternance",
  "Freelance",
  "Intérim",
  "Consultance",
  "Bénévolat",
  "Autre",
];
